import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import axios from '@utils/request'
import { IOneSubscriptionPayload } from '@app-store/slices/subscriptions/oneSubscription'
import { rootActions } from '@app-store/slices'

interface TaskAction extends Action {
    payload: IOneSubscriptionPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.subscriptions.oneSubscription

function* oneSubscriptionSagaTask({ payload }) {
    try {
        const response = yield axios.get(`/subscriptions/one/${payload.id}`)
        if (response.success) {
            yield put(onSuccess(response.result))
            if (payload.sagaCB) {
                yield payload.sagaCB?.onSuccess(response.result)
            }
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* oneSubscriptionSaga(): any {
    yield takeLatest<TaskAction>(onRequest, oneSubscriptionSagaTask)
}

export default oneSubscriptionSaga
